import './Cabinet.css';
import { useState, useEffect, useContext, createContext, useRef } from 'react';
import { LanguageContext } from './App';

function Cabinet({
}) {
    const { language, setLanguage } = useContext(LanguageContext);


    return (
    	<div className='cabinet-container'>
    		<div className='cabinet-elements'>
    			<div className='cabinet-element'>
    				<div className='cabinet-element-top'><img src='/images/cabinet-edit-icon.png' /></div>
    				<div className='cabinet-element-part'>
    					<div className='cabinet-photo'><img src='/images/cabinet-default-photo.png' /></div>
    					<h2>Veira User</h2>
    				</div>
    				<div className='app-separator-gray'></div>
    				<div className='cabinet-element-part'>
    					<div className='cabinet-element-part-data'>
    						<img src='/images/cabinet-phone-icon.png' />
    						<div><h3>Телефон:</h3><p>+7 (777) 777 7777</p></div>
    					</div>
    					<div className='cabinet-element-part-data'>
    						<img src='/images/cabinet-phone-icon.png' />
    						<div><h3>Телефон:</h3><p>+7 (777) 777 7777</p></div>
    					</div>
    				</div>
    			</div>
    			<div className='cabinet-element' style={{background: '#4886B9'}}>
    				<div className='cabinet-element-part' style={{justifyContent: 'center'}}>
    					<div className='cabinet-image'><img src='/images/cabinet-partner-icon.png' /></div>
    					<h2 style={{color: '#fff'}}>Стать партнером</h2>
    				</div>
    				<div className='app-separator-gray'></div>
    				<div className='cabinet-element-part' style={{justifyContent: 'center'}}>
    					<button>Подробнее</button>
    				</div>
    			</div>
    		</div>
            <div className='cabinet-orders-list'>
                <div className='cabinet-orders-list-top'>
                    <h2>Мои заказы</h2>
                </div>
                <div className='cabinet-orders-list-order'>
                    <div className='cabinet-orders-list-order-image'></div>
                    <h3>№136563</h3>
                    <p>Спрей с бактериофагами x2, Спрей для ног x3, </p>
                </div>
            </div>
    	</div>
    );
}

export default Cabinet;